<template lang="pug">
  .table-responsive
    .table-rounded-borders.mb-5
      table.table.table-bordered
        thead
          tr
            th {{ trans('labels.frontend.cart.table.item') }}
            th.text-right {{ trans('labels.frontend.cart.table.net_total') }}
        tbody
          tr(v-for="item in order.items" :key="item.id")
            td
              span {{ item.name }}
                strong.ml-2 x {{ item.quantity | numeral }}
            td.text-right ฿ {{ (item.price * item.quantity) | numeral }}
        tfoot
          tr(v-if="order.discount_total && order.discount_total > 0")
            td {{ trans('labels.frontend.cart.table.discount') }}
            td.text-right.text-primary - ฿ {{ order.discount_total }}
          tr
            td {{ trans('labels.frontend.cart.table.shipping_fees') }}
            td.text-right ฿ {{ order.shipping_total }}
          tr
            td {{ trans('labels.frontend.cart.table.net_total') }}
            td.text-right
              strong ฿ {{ order.net_total | numeral }}
</template>

<script>
export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
};
</script>
